module.exports = __webpack_public_path__ + "static/voyayge-blog-e8986b82add4e59ca21ff2752e687387.png";